import { Range } from "immutable";

import {
  createAPI,
  updateAPI,
  createLogoAPI,
  getAPI,
  getAllAPI,
  deleteAPI
} from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";

export const GET_AGENCIES = "GET_AGENCIES";
export const GET_AGENCIES_SUCCESS = "GET_AGENCIES_SUCCESS";
export const GET_AGENCIES_ERROR = "GET_AGENCIES_ERROR";
export const GET_AGENCIES_FINALLY = "GET_AGENCIES_FINALLY";

export const GET_AGENCY = "GET_AGENCY";
export const GET_AGENCY_SUCCESS = "GET_AGENCY_SUCCESS";
export const GET_AGENCY_ERROR = "GET_AGENCY_ERROR";
export const GET_AGENCY_FINALLY = "GET_AGENCY_FINALLY";

export const CREATE_AGENCY = "CREATE_AGENCY";
export const CREATE_AGENCY_SUCCESS = "CREATE_AGENCY_SUCCESS";
export const CREATE_AGENCY_ERROR = "CREATE_AGENCY_ERROR";
export const CREATE_AGENCY_FINALLY = "CREATE_AGENCY_FINALLY";

export const UPDATE_AGENCY = "UPDATE_AGENCY";
export const UPDATE_AGENCY_SUCCESS = "UPDATE_AGENCY_SUCCESS";
export const UPDATE_AGENCY_ERROR = "UPDATE_AGENCY_ERROR";
export const UPDATE_AGENCY_FINALLY = "UPDATE_AGENCY_FINALLY";

export const CREATE_AGENCY_LOGO = "CREATE_AGENCY_LOGO";
export const CREATE_AGENCY_LOGO_SUCCESS = "CREATE_AGENCY_LOGO_SUCCESS";
export const CREATE_AGENCY_LOGO_ERROR = "CREATE_AGENCY_LOGO_ERROR";
export const CREATE_AGENCY_LOGO_FINALLY = "CREATE_AGENCY_LOGO_FINALLY";

export const DELETE_AGENCY = "DELETE_AGENCY";
export const DELETE_AGENCY_SUCCESS = "DELETE_AGENCY_SUCCESS";
export const DELETE_AGENCY_ERROR = "DELETE_AGENCY_ERROR";
export const DELETE_AGENCY_FINALLY = "DELETE_AGENCY_FINALLY";

export const SET_AGENCY_PAGE = "SET_AGENCY_PAGE";
export const SET_AGENCY_SORT = "SET_AGENCY_SORT";
export const SET_AGENCY_SEARCH_FIELD = "SET_AGENCY_SEARCH_FIELD";

export const AGENCY_CLEAR_ERROR = "AGENCY_CLEAR_ERROR";
export const AGENCY_CLEAR_FORM = "AGENCY_CLEAR_FORM";
export const AGENCY_CLEAR_FORM_PREVIEW = "AGENCY_CLEAR_FORM_PREVIEW";

export const SET_DELETE_STATUS = "SET_DELETE_STATUS";

const validateCreate = (validate, msg, fields) =>
  validate(fields)
    .prop("name")
    .required(msg["app.validation.required"])
    .prop("url")
    .required(msg["app.validation.required"])
    .prop("agencyUrl")
    .required(msg["app.validation.required"])
    .prop("promotedMax")
    .required(msg["app.validation.required"])
    .getErrors();

export const getAll = () => async (dispatch, getState, utils) => {
  const data = getState().agency.meta.toJS();
  //console.log(data && data.toJS())

  const action = GET_AGENCIES;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAllAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const get = data => async (dispatch, getState, utils) => {
  const action = GET_AGENCY;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const createLogo = data => async (dispatch, getState, utils) => {
  const action = CREATE_AGENCY_LOGO;

  let formData = new FormData();
  formData.append("file", data[0]);

  try {
    const {
      status,
      body
    } = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      createLogoAPI,
      formData,
      null,
      body => {
        return new ValidationError(
          "logoFileUID",
          "Niepoprawny format lub wielkość pliku"
        );
      }
    );
    if (status === 200) {
      dispatch(setField(["agencyForm", "logoFileUID"], body.uid));
    }
    return { status, body };
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const create = data => async (dispatch, getState, utils) => {
  const action = CREATE_AGENCY;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      createAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const update = data => async (dispatch, getState, utils) => {
  const action = UPDATE_AGENCY;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      updateAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const deleteOne = data => async (dispatch, getState, utils) => {
  const action = DELETE_AGENCY;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      deleteAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );

    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const setPage = page => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_AGENCY_PAGE,
    payload: { page }
  });

  dispatch(getAll());
};

export const setSort = (field, dir) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_AGENCY_PAGE,
    payload: { page: 1 }
  });

  dispatch({
    type: SET_AGENCY_SORT,
    payload: { field, dir }
  });

  dispatch(getAll());
};

export const setSearchField = (field, value) => async (
  dispatch,
  getState,
  utils
) => {
  dispatch({
    type: SET_AGENCY_PAGE,
    payload: { page: 1 }
  });

  dispatch({
    type: SET_AGENCY_SEARCH_FIELD,
    payload: { field, value }
  });

  dispatch(getAll());
};

export const clearError = field => ({
  type: AGENCY_CLEAR_ERROR,
  payload: { field }
});

export const clearForm = () => ({
  type: AGENCY_CLEAR_FORM
});

export const clearFormPreview = () => ({
  type: AGENCY_CLEAR_FORM_PREVIEW
});

export const setDeleteStatus = status => ({
  type: SET_DELETE_STATUS,
  payload: { status }
});



// WEBPACK FOOTER //
// ./src/common/agency/actions.js